import { Box, Flex } from '@chakra-ui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/16/solid'
import {
  GreyGrey70,
  Lato13Bold,
  YellowYellow10,
  YellowYellow60
} from '@sequencehq/design-tokens'

export const ErrorIcon = (props: {
  size: 'small' | 'medium'
}) => {
  return (
    <Flex
      backgroundColor={YellowYellow10}
      height={props.size === 'small' ? '24px' : '48px'}
      width={props.size === 'small' ? '24px' : '48px'}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
    >
      <ExclamationTriangleIcon
        color={YellowYellow60}
        height={props.size === 'small' ? '16px' : '24px'}
        width={props.size === 'small' ? '16px' : '24px'}
      />
    </Flex>
  )
}

export const SectionError = (props: {
  text: string
  size: 'small' | 'medium'
}) => {
  return (
    <Flex
      flexDirection={props.size === 'small' ? 'row' : 'column'}
      alignItems="center"
      gap={props.size === 'small' ? '8px' : '16px'}
    >
      <ErrorIcon size={props.size} />
      <Box {...Lato13Bold} color={GreyGrey70}>
        {props.text}
      </Box>
    </Flex>
  )
}
